export default __webpack_public_path__ + "static/media/995.37013cf3.gif";